// extracted by mini-css-extract-plugin
module.exports = {"title_section":"listofferjunior_title_section__1ubeG","outer_card":"listofferjunior_outer_card__3e3uY"};